import React, { useState, useEffect } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './config/config';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './i18n';
import { useTranslation } from 'react-i18next';
import MainApp from './pages/MainApp';
import { initializeMsalInstance } from './services/authService';
import ErrorBoundary from './components/ErrorBoundary';

const msalInstance = new PublicClientApplication(msalConfig);

// Composant pour initialiser MSAL
const AppInitializer = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      const success = await initializeMsalInstance(msalInstance);
      if (success) {
        setInitialized(true);
      } else {
        setError(new Error('Failed to initialize MSAL'));
        // Même en cas d'erreur, continuer pour permettre à l'utilisateur de voir l'interface
        setInitialized(true);
      }
    };

    init();
  }, []);

  if (error) {
    return (
      <div className="msal-error-container">
        <h2>{t('msalInitError')}</h2>
        <p>{t('initFailed')}</p>
        <details>
          <summary>{t('errorDetails')}</summary>
          <pre>{error.message}</pre>
        </details>
      </div>
    );
  }

  if (!initialized) {
    return (
      <div className="app-loader">
        {t('initializing')}
      </div>
    );
  }

  return children;
};

function App() {
  return (
    <AppInitializer>
      <MsalProvider instance={msalInstance}>
        <ErrorBoundary>
          <MainApp />
        </ErrorBoundary>
        <ToastContainer position="top-right" autoClose={5000} />
      </MsalProvider>
    </AppInitializer>
  );
}

export default App;
